import './utils/loadCookieConsent';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { Actions } from './actions/enums';
import App from './App';
import { IdentityProvider } from './providers/IdentityProvider';
import { TranslationsProvider } from './providers/TranslationsProvider';
import { RedirectProvider } from './providers/RedirectProvider';

const container = document.createElement('div');
container.id = 'mv-agent-root';
document.body.appendChild(container);
const root = createRoot(container);

if (process.env.NODE_ENV === 'development' && !globalThis.ikea.pubsub) {
  let listeners: { msg: string; cb: (payload: unknown) => void }[] = [];
  const eventsHistory: { namespace: string; event: string; body: unknown; time: number }[] = [];
  if (!globalThis.ikea) {
    // @ts-expect-error It complains about us not setting pubsub, we do this the line after
    globalThis.ikea = {};
  }

  globalThis.ikea.pubsub = {
    subscribe: (msg: string, cb: (payload: unknown) => void) => listeners.push({ msg, cb }),
    unsubscribe: (targetMsg: string, targetCb?: (payload: unknown) => void) => {
      listeners = listeners.filter(({ msg, cb }) => msg !== targetMsg || cb !== targetCb);
    },
    eventsHistory,
    publish: (targetMsg: string, payload) => {
      eventsHistory.push({
        namespace: 'mv-agent-dev-mock',
        event: targetMsg,
        body: payload,
        time: Date.now(),
      });
      for (const entry of listeners) {
        if (entry.msg === targetMsg) {
          entry.cb(undefined);
        }
      }
    },
  };
}

root.render(
  <StrictMode>
    <TranslationsProvider>
      <IdentityProvider>
        <RedirectProvider>
          <App />
        </RedirectProvider>
      </IdentityProvider>
    </TranslationsProvider>
  </StrictMode>,
);

globalThis.ikea.mvAgent = globalThis.ikea.mvAgent ?? {};
globalThis.ikea.mvAgent.useSideMenu = () => true;

if (globalThis.ikea.mvAgent.useSideMenu()) {
  document.getElementById('hnf-header-profile')?.addEventListener?.('click', (e) => {
    e?.preventDefault?.();
    globalThis.ikea?.pubsub?.publish?.(Actions.PROFILE_OPEN_MENU);
  });
}
